export default __webpack_public_path__ + "static/media/webBlue.9fac371b.svg";